export default "__VITE_ASSET__DWeAgzse__"